import { useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import useAppStore from '../store/useAppStore'
import { getTelegramStartParam, getRouteFromStartParam } from '../utils/startParamMapper'

/**
 * Компонент для обработки deep linking из Telegram
 * Перенаправляет пользователя на нужную страницу на основе start_param
 */
const DeepLinkHandler = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { isFirstVisit } = useAppStore()
  const hasProcessedRef = useRef(false)

  useEffect(() => {
    // Обрабатываем deep link только один раз при монтировании
    if (hasProcessedRef.current) {
      return
    }

    // Получаем start_param из Telegram
    const startParam = getTelegramStartParam()

    if (!startParam) {
      hasProcessedRef.current = true
      return
    }

    console.log('[DeepLink] Received start_param:', startParam)

    // Преобразуем start_param в роут
    const targetRoute = getRouteFromStartParam(startParam)

    if (!targetRoute) {
      console.warn('[DeepLink] Invalid start_param, ignoring:', startParam)
      hasProcessedRef.current = true
      return
    }

    console.log('[DeepLink] Target route:', targetRoute)

    // Если пользователь первый раз заходит - приоритет у онбординга
    if (isFirstVisit) {
      console.log('[DeepLink] First visit detected, onboarding has priority')
      // Сохраняем целевой роут для редиректа после онбординга
      sessionStorage.setItem('pendingDeepLink', targetRoute)
      hasProcessedRef.current = true
      return
    }

    // Проверяем, не находимся ли мы уже на целевой странице
    if (location.pathname === targetRoute) {
      console.log('[DeepLink] Already on target route, skipping navigation')
      hasProcessedRef.current = true
      return
    }

    // Выполняем навигацию на целевую страницу
    console.log('[DeepLink] Navigating to:', targetRoute)
    navigate(targetRoute, { replace: true })
    hasProcessedRef.current = true
  }, [navigate, location.pathname, isFirstVisit])

  // Проверяем наличие отложенного deep link после завершения онбординга
  useEffect(() => {
    // Если онбординг завершен и есть отложенный deep link
    if (!isFirstVisit) {
      const pendingDeepLink = sessionStorage.getItem('pendingDeepLink')
      
      if (pendingDeepLink) {
        console.log('[DeepLink] Processing pending deep link after onboarding:', pendingDeepLink)
        sessionStorage.removeItem('pendingDeepLink')
        
        // Небольшая задержка для корректной работы навигации
        setTimeout(() => {
          navigate(pendingDeepLink, { replace: true })
        }, 100)
      }
    }
  }, [isFirstVisit, navigate])

  return children
}

export default DeepLinkHandler
